const maxItemsByScreenSize = (): number => {
  const cardWidth = 230;
  const itemsPerScreenSize = Math.floor(window.innerWidth / cardWidth);
  return itemsPerScreenSize > 3 ? 3 : itemsPerScreenSize;
};

export default maxItemsByScreenSize;
